const DEFAULT_RANGE = 45;
const DEFAULT_DAMPING = -0.05;
const SWIVEL_MINIMUM_DELTA = -4;
function linearNormalization(outMin, outMax, value) {
    const inMin = -1;
    const inMax = 1;
    const a = (outMax - outMin) / (inMax - inMin);
    const b = outMax - a * inMax;
    const normalizedValue = a * value + b;
    return normalizedValue;
}
function getRange(rangeOption) {
    const range = rangeOption || DEFAULT_RANGE;
    if (range > 2 * Math.PI) {
        return (range / 180) * Math.PI;
    }
    return range;
}
export class SwivelAnimation {
    constructor(geometry, options) {
        Object.defineProperty(this, "minRange", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "maxRange", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "applyDamping", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "elapsedTime", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "swivelGroup", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "shouldDamp", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "dampValue", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        Object.defineProperty(this, "resolveAnimation", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "activeState", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "completed", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "canceledState", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "initialRotation", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "tags", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        const range = getRange(options.range);
        this.minRange = -range;
        this.maxRange = range;
        this.elapsedTime = 0;
        this.swivelGroup = geometry;
        this.initialRotation = this.swivelGroup.rotation.y;
        this.shouldDamp = options.damping !== undefined;
        if (this.shouldDamp) {
            this.dampValue =
                options.damping === true ? DEFAULT_DAMPING : -options.damping;
        }
        this.applyDamping = this.shouldDamp
            ? // eslint-disable-next-line no-restricted-properties
                (value, elapsedTime) => value * Math.pow(Math.E, this.dampValue * elapsedTime)
            : (value) => value;
    }
    get isComplete() {
        return this.completed;
    }
    get isCanceled() {
        return this.canceledState;
    }
    resetMeshState() {
        this.swivelGroup.rotation.y = this.initialRotation;
    }
    cancel() {
        this.resetMeshState();
        this.resolveAnimation && this.resolveAnimation();
        this.canceledState = true;
    }
    get isActive() {
        return this.activeState;
    }
    update(delta) {
        if (this.isActive) {
            let value = Math.sin(this.elapsedTime);
            value = this.applyDamping(value, this.elapsedTime);
            if (this.shouldDamp &&
                this.dampValue * this.elapsedTime < SWIVEL_MINIMUM_DELTA) {
                this.activeState = false;
                this.completed = true;
                this.resolveAnimation && this.resolveAnimation();
            }
            const normalizedValue = linearNormalization(this.minRange, this.maxRange, value);
            this.swivelGroup.rotation.y = normalizedValue;
            this.elapsedTime += delta;
        }
    }
    // If the swivel is indefinite then the promise will instantly resolve.
    start() {
        this.activeState = true;
        if (this.shouldDamp) {
            return new Promise((resolve) => {
                this.resolveAnimation = resolve;
            });
        }
        return Promise.resolve();
    }
    resume() {
        if (this.resolveAnimation !== undefined) {
            this.activeState = true;
        }
    }
    stop() {
        this.activeState = false;
    }
}
//# sourceMappingURL=swivelAnimation.js.map